export default "__VITE_ASSET__ca9d7b63__"